import { openBlock as o, createElementBlock as t, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, e) {
  return o(), t("svg", n, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M11 16V7.85l-2.6 2.6L7 9l5-5 5 5-1.4 1.45-2.6-2.6V16zm-7 4v-5h2v3h12v-3h2v5z"
    }, null, -1)
  ])]);
}
const s = { render: r };
export {
  s as default,
  r as render
};
